var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HammerGestureConfig } from '@angular/platform-browser';
import 'hammerjs';
var HammerConfig = /** @class */ (function (_super) {
    __extends(HammerConfig, _super);
    function HammerConfig() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HammerConfig.prototype.buildHammer = function (element) {
        var mc = new window.Hammer(element, {
            touchAction: 'auto',
        });
        return mc;
    };
    return HammerConfig;
}(HammerGestureConfig));
export { HammerConfig };



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/hammer.config.ts.pre-build-optimizer.js